import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Grid2,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import { MuiOtpInput } from "mui-one-time-password-input";
// import { decode as base64_decode } from "base-64";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { api } from "../API/config";
import { axiosPrivate } from "../../axios/axios";
import { commonCss } from "../../StyleConfig/CommonCss";
import ErrorProps from "../../Component/Errorprops";

const OTPComp = () => {
  const code = useSelector((state) => state.auth.getEmailAndOTP);
  const [isLoading, setLoading] = useState(false);

  const navigate = useNavigate();

  const initialValues = { otp: "" };
  const onSubmit = (value) => {
    setLoading(true);
    // let decoded = base64_decode(code.code);
    // if (value.otp === decoded) {
    const postData = { emailId: code.emailId, otp: value.otp };
    const getLink = api.account.verifyOTP;
    axiosPrivate
      .post(`${getLink}`, postData)
      .then((res) => {
        console.log(res);
        navigate("/setpassword");
        setLoading(false);
      })
      .catch((e) => {
        toast.error(e.response.data.message);
        console.log(e);
        setLoading(false);
      });

    // toast.success("Success")

    // } else {
    //   toast.error("Invaild Code")
    //   setLoading(false)
    // }
  };

  const validationSchema = Yup.object({
    otp: Yup.string()
      .required("Please Fill The OTP")
      .min(6, "Complete the box")
      .max(6, "Complete the box"),
  });

  return (
    <Box
      sx={{
        background: "rgb(0, 86, 151)",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{
          background: "white",
          p: 1,
          borderRadius: "1.5rem",
          width: "50%",
        }}
      >
        <Grid2
          container
          sx={{ backgroundColor: "white", maxWidth: 600, padding: "2rem" }}
        >
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ setFieldValue, values, resetForm }) => (
              <Form>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
                >
                  <Typography
                    sx={{ fontWeight: 600, mb: "1rem", fontSize: "1.5rem" }}
                  >
                    Enter OTP
                  </Typography>
                  <Box>
                    <MuiOtpInput
                      length={6}
                      value={values.otp}
                      onChange={(e) => {
                        setFieldValue("otp", e);
                      }}
                    />
                    <ErrorMessage name="otp">
                      {(error) => <ErrorProps>{error}</ErrorProps>}
                    </ErrorMessage>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={isLoading}
                      fullWidth
                      sx={{
                        padding: "0.5rem",
                        mt: "0.7rem",
                        color: "white",
                        background: isLoading ? "default" : "rgb(0, 86, 151)",
                        "&:hover": {
                          backgroundColor: isLoading
                            ? "default"
                            : "rgb(0, 86, 151)",
                        },
                      }}
                    >
                      verify
                    </Button>
                  </Box>
                </Box>
              </Form>
            )}
          </Formik>
        </Grid2>
      </Paper>
    </Box>
  );
};

export default OTPComp;




